document.addEventListener('turbo:load', initRGVC)
document.addEventListener('DOMContentLoaded',  initRGVC)

function initRGVC() {
  const copyBox  = document.getElementById('rgvc-copy')
  if (!copyBox || window.innerWidth <= 1024) return

  const titleEl  = document.getElementById('rgvc-title')
  const bodyEl   = document.getElementById('rgvc-body')
  const items    = document.querySelectorAll('[data-rgvc-item]')

  const io = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const { title, body } = entry.target.dataset
          titleEl.textContent = title
          bodyEl.textContent  = body
        }
      })
    },
    { root: null, threshold: 0.55 } // 55 % of the span visible ≈ “active”
  )

  items.forEach(el => io.observe(el))
}
